<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_416_15230)">
      <path
        d="M15.8292 4.50195L9.49907 10.8321L6.16741 7.50045L1.16992 12.4979M15.8292 4.50195H11.8311M15.8292 4.50195L15.829 8.49994"
        stroke="#F7F8FD"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_416_15230">
        <rect
          width="17"
          height="17"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>